import React from 'react';
import Popper from '@mui/material/Popper';

// Вид выпадающих списков форм компании. Список открывается под полем и не перескакивает наверх,
// когда внизу экрана мало места: сверху он закрывал соседние поля формы. Страница при этом
// просто прокручивается.
export const UnderTheField = (props) => (
  <Popper {...props} placement="bottom-start" modifiers={[{ name: 'flip', enabled: false }]} />
);

// Список невысокий (около семи названий, остальные прокруткой): по умолчанию он занимает 40% экрана.
export const LISTBOX_PROPS = { style: { maxHeight: 252 } };
